import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface Only2PhotosModel extends BaseModel {
  variables?: { [key: string]: string } | Only2PhotosVariables;
}

export interface Only2PhotosVariables {
  FirstImage: string;
  SecondImage: string;
  FirstImageHref: string;
  SecondImageHref: string;
  FirstImageAlt: string;
  SecondImageAlt: string;
  FirstImageHrefSegmentRegex: string;
  SecondImageHrefSegmentRegex: string;
}

export class Only2PhotosInitVariables implements Only2PhotosVariables {
  FirstImage = '';
  SecondImage = '';
  FirstImageHref = '';
  SecondImageHref = '';
  FirstImageAlt = '';
  SecondImageAlt = '';
  FirstImageHrefSegmentRegex = '';
  SecondImageHrefSegmentRegex = '';
}

export class Only2PhotosInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new Only2PhotosInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
